import React from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'

// Import styled components
import {
  StatitisIcon,
  StatitisDescription,
  StatitisTitle
} from './StatitisResponsive'

// Import common modules
import { FlexBox, Box } from '../../common/Box'

// Css
import './styles/StatitisItem.css'

// Defined component Statitis
class StatitisItem extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      isAnimate: false
    }
  }

  // handling scroll event
  handleScroll = () => {
    const offsetTop = (ReactDOM.findDOMNode(this).getBoundingClientRect().top - window.innerHeight)

    if (offsetTop <= 0) {
      this.setState({
        isAnimate: true
      })
    } else {
      this.setState({
        isAnimate: false
      })
    }
  }

  componentDidMount() {
    document.addEventListener('scroll', this.handleScroll, false)
  }

  componentWillUnmount() {
    document.removeEventListener('scroll', this.handleScroll, false)
  }

  render() {
    const { customStyle, text, icon, title, className } = this.props
    return (
      <FlexBox
        alignItems='center'
        justifyContent='center'
        style={customStyle}
        className={this.state.isAnimate ? className : ''}
      >
        <StatitisIcon icon={icon} type={icon} />
        <Box>
          <StatitisDescription type='xxLarge' text={text} />
          <StatitisTitle type='xxSmall' title={title} />
        </Box>
      </FlexBox>
    )
  }
}

StatitisItem.propTypes = {
  icon: PropTypes.string,
  text: PropTypes.string,
  title: PropTypes.string
}

StatitisItem.defaultProps = {
  icon: '',
  text: '',
  title: ''
}

export default StatitisItem



// WEBPACK FOOTER //
// ./src/components/sections/statitis/StatitisItem.js